import { getOrganizationBranches } from 'src/graphql/queries/branches.graphql';
import type {
  IGetOrganizationBranchesQuery,
  IGetOrganizationBranchesQueryVariables,
} from 'src/graphql/queries/branches.graphql.types';
import useRootUserRevalidation from 'src/hooks/useRootUserRevalidation';
import { useQuery } from 'urql';

const useOrganizationBranches = ({ owned = false }: { owned?: boolean }) => {
  const [{ data, error, fetching, stale }, refetch] = useQuery<
    IGetOrganizationBranchesQuery,
    IGetOrganizationBranchesQueryVariables
  >({
    query: getOrganizationBranches,
    variables: {
      owned,
    },
    requestPolicy: 'cache-and-network',
  });

  useRootUserRevalidation({ refetch });

  return {
    data,
    error,
    fetching,
    stale,
    branches: data?.organization.branches || [],
  };
};

export default useOrganizationBranches;
